let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("bUPwj")]).then(() => parcelRequire('4z8RD'));